import { FormattedMessage } from 'react-intl';

type UploadProgressMessageProps = {
  progress: number | null;
};

const UploadProgressMessage = ({ progress }: UploadProgressMessageProps) => {
  if (progress === null) {
    return (
      <FormattedMessage id="portfolio.challenge.files.add.upload_file.uploading_state.simple" />
    );
  }

  return (
    <FormattedMessage
      id="portfolio.challenge.files.add.upload_file.uploading_state.with_progress"
      values={{
        progress,
      }}
    />
  );
};

export default UploadProgressMessage;
